import React, { Component } from 'react';

import PropTypes from 'prop-types';

import './Badge.scss';

class Badge extends Component {
  static propTypes = {
    value: PropTypes.node,
    className: PropTypes.string
  };

  static defaultProps = {
    value: 0,
    className: ''
  };

  render() {
    const { className, value } = this.props;
    const classComponent = `badge--default ${className}`;

    return <div className={classComponent}>{value}</div>;
  }
}

export default Badge;
